<template>
  <div class="history-museum">
    <div class="item-div">
      <p class="year">HONOURS</p>
      <p class="title record">FA CUP 4회 우승!토너먼트 절대 강자! 전남드래곤즈!</p>
      <img class="record-img" src="@/assets/img/club/history/record_01.png" alt="record_01">

      <div v-for="(item, index) in list" :key="index" class="table-div">
        <table class="season-table">
          <caption>{{item.title}}</caption>
          <thead>
          <tr>
            <td v-for="(item, index) in theadList" :key="index">{{item}}</td>
          </tr>
          </thead>
          <tbody v-if="item.desc.length > 0">
          <tr v-for="(desc, idx) in item.desc" :key="idx">
            <td>{{desc.season}}</td>
            <td>{{desc.grade}}</td>
            <td>{{desc.mvp}}</td>
            <td>{{desc.individual}}</td>
          </tr>
          </tbody>
          <tbody v-else class="tbody-empty">
          <tr>
            <td colspan="4" class="center">
              <div class="empty"></div>
              <p>내역이 없습니다.</p>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="item-div" style="padding-top: 70px">
      <p class="year">K LEAGUE</p>
      <p class="title record">정규리그 기준 전남드래곤즈 승/무/패/득점 기록</p>
      <div class="table-div">
        <table class="season-table">
          <caption>정규리그 통산(2025년 시즌종료 기준)</caption>
          <thead>
          <tr>
            <td v-for="(item, index) in subTheadList" :key="index">{{item}}</td>
          </tr>
          </thead>
          <tbody v-if="kLeagueList1.length > 0">
          <tr v-for="(desc, idx) in kLeagueList1" :key="idx">
            <td>{{comma(desc.win)}}</td>
            <td>{{comma(desc.draws)}}</td>
            <td>{{comma(desc.loss)}}</td>
            <td>{{comma(desc.score)}}골</td>
          </tr>
          </tbody>
          <tbody v-else class="tbody-empty">
          <tr>
            <td colspan="4" class="center">
              <div class="empty"></div>
              <p>내역이 없습니다.</p>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="team-page">
      <div class="rank-div">
        <div class="ranking" v-for="(item, i) in kLeagueList2" :key="i">
          <p class="title">{{item.title}}</p>
          <div class="rankingBox p0" v-if="item.firstList.length">
            <table class="first-table">
              <tbody class="first">
              <tr v-for="(team, index) in item.firstList" :key="index">
                <td class="info">
                  <ul>
                    <li>{{index+1}}위 <span v-if="item.different">{{team.year}}년</span></li>
                    <li class="name">{{team.name}}</li>
                  </ul>
                </td>
                <td class="img" colspan="2">
                  <img :src="imageSrc(team.img)" alt="">
                </td>
                <td class="score" :class="{assist: item.different}">
                  <ul v-if="item.different">
                    <li>{{team.goal}}GOAL</li>
                    <li class="game">{{team.match}}GAME</li>
                  </ul>
                  <ul v-else>
                    <li>{{team.match}}</li>
                    <li class="year">{{team.year}}</li>
                  </ul>
                </td>
              </tr>
              </tbody>
            </table>
            <table>
              <tbody v-for="(team, index) in item.desc" :key="index">
              <tr v-if="item.different">
                <td class="rank" style="width: 10%">{{index+2}}</td>
                <td class="name diff">{{team.name}} <span>({{team.year}}년)</span></td>
                <td class="goal" style="width: 20%">{{team.goal}}골</td>
                <td class="game" style="width: 20%">{{team.match}}경기</td>
              </tr>
              <tr v-else>
                <td class="rank" style="width: 10%">{{index+2}}</td>
                <td class="name">{{team.name}}</td>
                <td class="goal" style="width: 22%">{{team.match}}</td>
                <td class="game" style="width: 20%" v-html="team.year"></td>
              </tr>
              <tr v-if="item.desc.length != index+1" class="line">
                <td class="space" colspan="5"></td>
              </tr>
              </tbody>
            </table>
          </div>

          <p v-if="item.title === '역대 최다 경기출전자 TOP5'" class="rank-footer">※1995~2011까지 리그컵 포함</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {comma} from '../../lib';

export default {
  name: 'Record',
  data() {
    return {
      list: [],
      kLeagueList1: [],
      kLeagueList2: [],
      theadList: ['시즌', '성적', 'MVP', '개인상'],
      subTheadList: ['승', '무', '패', '총 득점'],
    }
  },
  mounted () {
    this.init();
  },
  methods: {
    comma,
    init() {
      this.list = [
        {
          title: 'FA CUP',
          desc: [
            {
              season: '2021',
              grade: '우승',
              mvp: '정재희',
              individual: '득점왕 박희성'
            }, {
              season: '2007',
              grade: '우승',
              mvp: '김치우',
              individual: '-'
            }, {
              season: '2006',
              grade: '우승',
              mvp: '김효일',
              individual: '-'
            }, {
              season: '2003',
              grade: '준우승',
              mvp: '-',
              individual: '-'
            }, {
              season: '1997',
              grade: '우승',
              mvp: '김정혁',
              individual: '득점왕 노상래'
            }
          ]
        }, {
          title: '대한화재컵',
          desc: [
            {
              season: '2000',
              grade: '준우승',
              mvp: '-',
              individual: '-'
            }
          ]
        }, {
          title: '라피도컵',
          desc: [
            {
              season: '1997',
              grade: '준우승',
              mvp: '-',
              individual: '-'
            }
          ]
        }, {
          title: '아디다스컵',
          desc: [
            {
              season: '1997',
              grade: '준우승',
              mvp: '-',
              individual: '-'
            }
          ]
        }, {
          title: '아시안컵 위너스컵',
          desc: [
            {
              season: '1999',
              grade: '준우승',
              mvp: '-',
              individual: '-'
            }
          ]
        }
      ];

      this.kLeagueList1 = [
        {
          win: 368,
          draws: 342,
          loss: 423,
          score: 1376
        }
      ];

      this.kLeagueList2 = [
        {
          title: '역대 최다 경기출전자 TOP5',
          firstList: [{
            name: '김태영',
            match: '250GAME',
            year: '1995~2005',
            img: 'record_k_league_01'
          }],
          desc: [
            {
              name: '김영욱',
              match: '238경기',
              year: '2010~2019'
            }, {
              name: '노상래',
              match: '219경기',
              year: '1995-2002'
            }, {
              name: '김도근',
              match: '206경기',
              year: '1995~2005'
            }, {
              name: '이종호',
              match: '195경기',
              year: `2011~2015<br>2020~2021`
            }
          ]
        }, {
          title: '역대 최다 득점자 TOP5',
          firstList: [{
            name: '노상래',
            match: '71GOAL',
            year: '1995~2002',
            img: 'record_k_league_02'
          }],
          desc: [
            {
              name: '이종호',
              match: '48골',
              year: `2011~2015<br>2020~2021`
            }, {
              name: '발디비아',
              match: '42골',
              year: '2023~2025'
            }, {
              name: '세자르',
              match: '36골',
              year: '1999~2002'
            }, {
              name: '김도근',
              match: '34골',
              year: '1995~2005'
            }
          ]
        }, {
          title: '역대 최다 도움기록 TOP5',
          firstList: [{
            name: '노상래',
            match: '39ASSIST',
            year: '1995~2002',
            img: 'record_k_league_02'
          }],
          desc: [
            {
              name: '발디비아',
              match: '29도움',
              year: '2023~2025'
            }, {
              name: '김종현',
              match: '23도움',
              year: '1998~2002'
            }, {
              name: '김도근',
              match: '22도움',
              year: '1995~2005'
            }, {
              name: '김영욱',
              match: '20도움',
              year: '2010~2019'
            }
          ]
        }, {
          title: '단일시즌 최다 득점기록 TOP5',
          different: true,
          firstList: [{
            name: '이따마르',
            year: '2003',
            goal: 23,
            match: 34,
            img: 'record_k_league_03'
          }],
          desc: [
            {
              name: '발디비아',
              year: '2025',
              goal: 16,
              match: 32
            }, {
              name: '자일',
              year: '2017',
              goal: 16,
              match: 35
            }, {
              name: '노상래',
              year: '1995',
              goal: 15,
              match: 26
            }, {
              name: '모따',
              year: '2004',
              goal: 14,
              match: 22
            }
          ]
        }
      ];
    },
    imageSrc(imgSrc) {
      return require('@/assets/img/club/history/'+imgSrc+'.png');
    },
  }
}
</script>
